//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const dataList = [{
    src:"",
    name:"设备管理",
    tags:["PostgreSQL","Oracle","PostgreSQL","Oracle"],
    discount:["2年8折","3年6折"],
    money:"2000.00"
},{
    src:"",
    name:"设备管理",
    tags:["PostgreSQL"],
    discount:["2年8折"],
    money:"2000.00"
},{
    src:"",
    name:"设备管理",
    tags:["PostgreSQL","Oracle"],
    discount:["2年8折","3年6折"],
    money:"2000.00"
}]

export default {
    components: {

    },
    created(){
        this.getHotSearch();
        this.getHistorySearch();
    },
    data () {
        return {
         dataList: dataList,
         hotSearch:"",
         historyWord:[],
         newHistoryWord:[],
         model:{},
         index:0,
         storage:{},
        }
    },
    methods: {
        getHotSearch(){
            this.$http.post(this.global.httpUrl + '/rest/v1/demandList/getDemandHotWords',this.model,{emulateJSON:true}).then(function(res){
                    if(res.body.success)
                    { 
                 this.hotSearch= res.body.row;
                    }    
                },function(res){
            });
        },
        getHistorySearch(){
            this.storage=window.localStorage;
          for(var i=1;i<11;i++){
              if( this.storage.getItem('search_'+i)!= null){
                  this.newHistoryWord.push({"historyWord":this.storage.getItem('search_'+i)});
              }else{
                  return;
              }
          }
        },
        goSearch(){
            console.log(this.model.demandName);
            if(this.model.demandName!=null && this.model.demandName!=""){
            //第一次的时候，设置1
        if(localStorage.getItem("index")==null){
        localStorage.setItem("index",1);
        localStorage.setItem("search_1",this.model.demandName); 
        }else{
         var index=localStorage.getItem("index");
        //如果到10了重置为1
        if(index==10){
            index=1
        }else{
        index++;
        }
         localStorage.setItem("index",index);
        localStorage.setItem("search_"+index,this.model.demandName); 
        }    
           this.index++;
           this.storage.setItem(this.index, this.model.demandName);
          console.log(this.storage);
            }
        },
        goBack(){
           
        }
    }
}



// WEBPACK FOOTER //
// ./src/views/saas/saasSearch.vue